'use strict';
angular.module('productManageMentWeiXinModule', ['productManagementWeixinServiceModule']).controller('productManageMentWeiXinCtrl', [
    '$scope',
    'trsHttpService',
    'modalDialog',
    '$state',
    'trsspliceString',
    'productManagementWeixinService',
    '$q',
    '$timeout',
    'productManageMentService',
    function ($scope, trsHttpService, modalDialog, $state, trsspliceString, productManagementWeixinService, $q, $timeout, productManageMentService) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            ($scope.data = {
                items: [],
                selectedArray: [],
            });
            ($scope.status = {
                // 是否是水印管理界面
                // isWatermark: false,
                // 水印管理的左上角名称
                // watermarkTitle: '',
                // mediaType: editingMediatype.weixin,
            });
        }

        /**
         * [weChatSync description]微信同步
         * @return {[type]} [description]
         */
        $scope.weChatSync = function () {
            var params = {
                serviceid: 'mlf_wechatgroupsend',
                methodname: 'sycnWechatAccount',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                modalDialog.alertType('同步成功', '', 'success', false, function () {
                    requestData();
                    $scope.data.selectedArray = [];
                });
            });
        };

        /**
         * [selectAll description]全选
         * @return {[type]} [description]
         */
        $scope.selectAll = function () {
            $scope.data.selectedArray = $scope.data.selectedArray.length === $scope.data.items.length ? [] : [].concat($scope.data.items);
        };

        /**
         * [selectDoc description]
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.selectDoc = function (item) {
            var index = $scope.data.selectedArray.indexOf(item);
            if (index < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice(index, 1);
            }
        };

        /**
         * [initData description]初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            requestData().then(function () {
                getWeichatType();
            });
        }

        /**
         * [requestData description]刷新列表
         * @return {[type]} [description]
         */
        function requestData() {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_wechatconfig',
                methodname: 'queryChannelsBySite',
                ChnlDesc: $scope.keywords,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                $scope.data.items = data;
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
         * [modifySubscription description]
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.modifySubscription = function (item) {
            productManagementWeixinService.modifySubscription(item, function (data) {
                var params = data;
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    if (data.ISSUCCESS === 'true') {
                        modalDialog.alertType('保存成功', '', 'success', false, function () {
                            requestData();
                            $scope.data.selectedArray = [];
                        });
                    }
                    requestData();
                });
            });
        };

        /**
         * [getWeichatType description]获取公众号类别
         * @return {[type]} [description]
         */
        function getWeichatType() {
            var params = {
                serviceid: 'mlf_wechatgroupsend',
                methodname: 'getChannelType',
                ChannelIds: trsspliceString.spliceString($scope.data.items, 'CHANNELID', ','),
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $scope.data.weichatType = data;
            });
        }

        /**
         * [requestData description]刷新列表
         * @return {[type]} [description]
         */
        $scope.requestData = function () {
            requestData();
        };

        /**
         * [searchRequestData description]
         *
         * @param   {[type]}  $event  [$event description]
         *
         * @return  {[type]}          [return description]
         */
        $scope.searchRequestData = function ($event) {
            if ($event !== undefined && $event.keyCode !== 13) {
                return;
            }
            requestData();
        };

        /**
         * [watermarkMGR description]水印管理页面
         *
         * @param   {[type]}  item    [item description]
         * @param   {[type]}  trench  [trench description]
         *
         * @return  {[type]}          [return description]
         */
        $scope.watermarkMGR = function (item, trench) {
            productManageMentService.toWatermarkMGR(item, trench);
        };
        
        /**
        * [showkuaibaoList description]
        *
        * @param   {[type]}  item  [item description]
        *
        * @return  {[type]}        [return description]
        */
        $scope.showkuaibaoList = function (item) {
            productManagementWeixinService.wechatModal(item).then((res) => {
                let params = {
                    serviceid: 'mlf_wechatconfig',
                    methodName: 'bandKuaiBaoAccount',
                    CHANNELID: item.CHANNELID,
                    KUAIBAOACCOUNTID: res.data.KUAIBAOACCOUNTID ? res.data.KUAIBAOACCOUNTID : '0',
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((data) => {
                    modalDialog.alertType(
                        data.DETAIL,
                        '',
                        'success',
                        false,
                        function () {
                            requestData();
                        },
                        '',
                        1500
                    );
                });
            });
        };

        /**
         * [bindAAccount description]
         *
         * @param   {[type]}  id  [id description]
         *
         * @return  {[type]}      [return description]
         */
        $scope.bindAAccount = function (id) {
            let params = {
                mediaChannel: 'WECHAT',
                methodname: 'getAuthorizedUrl',
                productId: id,
                serviceid: 'zmy_product'
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((data) => {
                let url = data.DATAS;
                window.open(url);  
                $timeout(function() {
                    productManagementWeixinService.newWechatBindModel(url).then((result) => {
                        requestData().then(function() {
                            getWeichatType();
                        });
                        $scope.data.selectedArray = [];
                    });
                }, 500);  
            });       
        };
        $scope.deleat = function(item) {
            modalDialog.alertType('提示信息', '您确定要删除所选账号吗', 'ask', true, function() {
                let params = {
                    MediaType: 4,
                    methodname: 'deleteProducts',
                    ProductIds: item ? item.CHANNELID : trsspliceString.spliceString($scope.data.selectedArray, 'CHANNELID', ','),
                    serviceid: 'zmy_product'
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((data) => {
                    requestData();
                    $scope.data.selectedArray = [];
                }, function() {
                    requestData();
                    $scope.data.selectedArray = [];
                });
            });
            
        };

        /**
         * [sort description]排序
         *
         * @return  {[type]}  [return description]
         */
        $scope.sort = function() {
            if ($scope.data.selectedArray.length > 1) {
                modalDialog.alertType('只能选择一个微信账号', '', 'warning', false);
                return;
            } else {
                productManageMentService.resetAccountOrder('weixin', $scope.data.selectedArray[0], $scope.data.items, function(result) {
                    if (result === 'success') {
                        modalDialog.alertType('排序成功', '', 'success', false);
                        requestData();
                        $scope.data.selectedArray = [];
                    } else {
                        modalDialog.alertType('排序失败', result.DETAIL, 'error', 'confirm');
                    }
                });
            } 
        };

        /**
         * [itenInit description] index初始化
         * @param  {[Object]} item   [description] 微博账号
         * @param  {[Number]} $index [description] 微博顺序
         * @return {[type]}        [description]
         */
        $scope.itemInit = function(item, $index) {
            item.index = $index + 1;
            getRights(item);
        };

        /**
         * [getWeiboRights description]获取微博权限
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        function getRights(item) {
            productManagementWeixinService.getOperRight(item.CHANNELID).then(function(data) {
                item.rights = data;
            });
        }
    },
]);
